import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AuthService from './AuthService'

const AppContext = React.createContext({
  auth: '',
  refreshAuthentication: () => {},
  userPermissions: [] as string[],
  needsPasswordChange: false,
  isAdUser: false,
  refreshUserDetails: () => {},
  isLicensed: false,
  setLicensed: (isLicensed: boolean) => {},
  licenseStatus: '' as string,
  setLicenseStatus: (licenseStatus: string) => {},
  isClusterSlotReserved: false,
  setClusterSlotReserved: (isClusterSlotReserved: boolean) => {},
  changeLanguage: (language: string) => {},
})

export const ContextComponent: FC<{}> = ({ children }) => {
  const [auth, setAuth] = useState(AuthService.getAuthToken())
  const [userPermissions, setUserPermissions] = useState(AuthService.getPermissions())
  const [needsPasswordChange, setNeedsPasswordChange] = useState(AuthService.getNeedsPasswordChange())
  const [isAdUser, setIsAdUser] = useState(AuthService.getIsAdUser())
  const { i18n } = useTranslation()
  const [isLicensed, setLicensed] = useState(false)
  const [licenseStatus, setLicenseStatus] = useState('' as string)
  const [isClusterSlotReserved, setClusterSlotReserved] = useState(false)

  function changeLanguage(language: string) {
    window.localStorage.setItem('language', language)
    i18n.changeLanguage(language)
  }

  function refreshAuthentication() {
    setAuth(AuthService.getAuthToken())
  }

  function refreshUserDetails() {
    setNeedsPasswordChange(AuthService.getNeedsPasswordChange())
    setIsAdUser(AuthService.getIsAdUser())
    setUserPermissions(AuthService.getPermissions())
  }

  return (
    <AppContext.Provider
      value={{
        auth,
        refreshAuthentication,
        userPermissions,
        needsPasswordChange,
        isAdUser,
        refreshUserDetails,
        changeLanguage,
        isLicensed,
        setLicensed,
        licenseStatus,
        setLicenseStatus,
        isClusterSlotReserved,
        setClusterSlotReserved,
      }}>
      {children}
    </AppContext.Provider>
  )
}

export default AppContext
